// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_box__0yj2J {
    /*--box-width: clamp(150px, 10vw, 225px);*/
    /*--box-height: clamp(70px, 5vw, 107px);*/

    display: flex;
    position: relative;
    transition:
        width 0.4s,
        margin 0.4s;
    width: var(--box-width);
    height: var(--box-height);
    min-height: var(--box-height);
    /*min-height: 117px;*/
}

/*.box.smaller,*/
.styles_box__0yj2J.styles_open__Tsm2e {
    --box-width: var(--box-width-sm);
    --box-height: var(--box-height-sm);
}

.styles_box__0yj2J.styles_vertical__Gbefe:first-child {
    --margin-offset: 8px;
    padding-left: calc(var(--length, attr(data-items)) * var(--margin-offset));
}

.styles_box__0yj2J:first-child[data-items='1'] {
    --length: 1;
}

.styles_box__0yj2J:first-child[data-items='2'] {
    --length: 2;
}
.styles_box__0yj2J:first-child[data-items='3'] {
    --length: 3;
}
.styles_box__0yj2J:first-child[data-items='4'] {
    --length: 4;
}
.styles_box__0yj2J:first-child[data-items='5'] {
    --length: 5;
}
.styles_box__0yj2J:first-child[data-items='6'] {
    --length: 6;
}

.styles_box__0yj2J:not(.styles_vertical__Gbefe):not(.styles_smaller__A9U6Q) {
    margin: auto;
}

.styles_boxInner__4WAHc {
    display: flex;
    min-height: var(--box-height);
    transition:
        margin 0.4s,
        width 0.4s,
        min-width 0.4s,
        padding 0.4s;
}

.styles_boxContent__a5oph {
    display: flex;
    min-height: var(--box-height);
}

.styles_horizontal__4RlLx {
    flex-direction: row;
    justify-content: center;
    min-width: 100%;
    flex-wrap: wrap;
}

.styles_horizontal__4RlLx .styles_boxContent__a5oph {
    flex-direction: row;
    justify-content: center;
    min-width: 100%;
    flex-wrap: wrap;
}

.styles_vertical__Gbefe {
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.styles_vertical__Gbefe .styles_boxContent__a5oph {
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.styles_vertical__Gbefe:not(.styles_open__Tsm2e) {
    /*animation: justify 0.4s;*/
    /*animation-fill-mode: forwards;*/
}

.styles_bottom__xWFj3 {
    align-content: flex-end;
}

@keyframes styles_justify__VumoO {
    0% {
        justify-content: center;
    }
    99.99% {
        justify-content: center;
    }
    100% {
        justify-content: flex-start;
    }
}

.styles_horizontal__4RlLx.styles_open__Tsm2e {
    width: 900px;
    /*margin-left: -225px;*/
}

.styles_vertical__Gbefe {
    margin-top: 0;
    margin-bottom: 0;
    transition: margin 0.4s;
}

.styles_vertical__Gbefe.styles_open__Tsm2e {
    /*margin-top: -192px;*/
    /*margin-bottom: -140px;*/

    margin-top: calc(var(--box-height) * -1);
    margin-bottom: calc(var(--box-height) * -1);
}

/*.vertical.open.yOffest {*/
/*    padding-top: 70px;*/
/*}*/

.styles_absolute__oIuM9 {
    /*position: absolute;*/
    /*top: 0;*/
    /*bottom: 0;*/
    margin: -140px 0;
}

.styles_placeholder__qVABa {
    opacity: 0;
    transition: opacity 0.4s;
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
    grid-gap: 12px;
}

.styles_horizontal__4RlLx .styles_placeholder__qVABa {
    top: -40px;
    left: 0;
}

.styles_vertical__Gbefe .styles_placeholder__qVABa {
    left: 28px;
    top: 40px;
}

.styles_open__Tsm2e .styles_placeholder__qVABa {
    opacity: 1;
}

/*.smaller:not(.open) {*/
/*    --box-width: 224px;*/
/*    --box-height: 105px;*/
/*}*/

.styles_smaller__A9U6Q .styles_boxInner__4WAHc {
    align-items: flex-end;
    justify-content: flex-end;
}

.styles_smaller__A9U6Q {
    margin: auto;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_box__0yj2J:not(.styles_open__Tsm2e).styles_smaller__A9U6Q {
        margin-right: 0;
    }

    .styles_box__0yj2J.styles_open__Tsm2e.styles_smaller__A9U6Q {
        margin-right: 7px;
    }

    .styles_box__0yj2J {
        /*--box-width: 150px !important;*/
        /*--box-height: 70px !important;*/
        /*width: 150px !important;*/
        /*min-width: 150px !important;*/
        /*height: 70px !important;*/
        /*min-height: 70px !important;*/
        /*padding: 10px;*/
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageView/StorageMainViews/components/StorageBoxGroup/styles.module.css"],"names":[],"mappings":"AAEA;IACI,0CAA0C;IAC1C,yCAAyC;;IAEzC,aAAa;IACb,kBAAkB;IAClB;;mBAEe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,0EAA0E;AAC9E;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B;;;;oBAIgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;;IAEzB,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA,2BAA2B;AAC3B,yBAAyB;AACzB,IAAI;;AAEJ;IACI,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,OAAO;AACX;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA,wBAAwB;AACxB,0BAA0B;AAC1B,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iCAAiC;QACjC,iCAAiC;QACjC,2BAA2B;QAC3B,+BAA+B;QAC/B,2BAA2B;QAC3B,+BAA+B;QAC/B,iBAAiB;IACrB;AACJ","sourcesContent":["@value screen-md-max from '../../../../../../breakpoints.css';\n\n.box {\n    /*--box-width: clamp(150px, 10vw, 225px);*/\n    /*--box-height: clamp(70px, 5vw, 107px);*/\n\n    display: flex;\n    position: relative;\n    transition:\n        width 0.4s,\n        margin 0.4s;\n    width: var(--box-width);\n    height: var(--box-height);\n    min-height: var(--box-height);\n    /*min-height: 117px;*/\n}\n\n/*.box.smaller,*/\n.box.open {\n    --box-width: var(--box-width-sm);\n    --box-height: var(--box-height-sm);\n}\n\n.box.vertical:first-child {\n    --margin-offset: 8px;\n    padding-left: calc(var(--length, attr(data-items)) * var(--margin-offset));\n}\n\n.box:first-child[data-items='1'] {\n    --length: 1;\n}\n\n.box:first-child[data-items='2'] {\n    --length: 2;\n}\n.box:first-child[data-items='3'] {\n    --length: 3;\n}\n.box:first-child[data-items='4'] {\n    --length: 4;\n}\n.box:first-child[data-items='5'] {\n    --length: 5;\n}\n.box:first-child[data-items='6'] {\n    --length: 6;\n}\n\n.box:not(.vertical):not(.smaller) {\n    margin: auto;\n}\n\n.boxInner {\n    display: flex;\n    min-height: var(--box-height);\n    transition:\n        margin 0.4s,\n        width 0.4s,\n        min-width 0.4s,\n        padding 0.4s;\n}\n\n.boxContent {\n    display: flex;\n    min-height: var(--box-height);\n}\n\n.horizontal {\n    flex-direction: row;\n    justify-content: center;\n    min-width: 100%;\n    flex-wrap: wrap;\n}\n\n.horizontal .boxContent {\n    flex-direction: row;\n    justify-content: center;\n    min-width: 100%;\n    flex-wrap: wrap;\n}\n\n.vertical {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.vertical .boxContent {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.vertical:not(.open) {\n    /*animation: justify 0.4s;*/\n    /*animation-fill-mode: forwards;*/\n}\n\n.bottom {\n    align-content: flex-end;\n}\n\n@keyframes justify {\n    0% {\n        justify-content: center;\n    }\n    99.99% {\n        justify-content: center;\n    }\n    100% {\n        justify-content: flex-start;\n    }\n}\n\n.horizontal.open {\n    width: 900px;\n    /*margin-left: -225px;*/\n}\n\n.vertical {\n    margin-top: 0;\n    margin-bottom: 0;\n    transition: margin 0.4s;\n}\n\n.vertical.open {\n    /*margin-top: -192px;*/\n    /*margin-bottom: -140px;*/\n\n    margin-top: calc(var(--box-height) * -1);\n    margin-bottom: calc(var(--box-height) * -1);\n}\n\n/*.vertical.open.yOffest {*/\n/*    padding-top: 70px;*/\n/*}*/\n\n.absolute {\n    /*position: absolute;*/\n    /*top: 0;*/\n    /*bottom: 0;*/\n    margin: -140px 0;\n}\n\n.placeholder {\n    opacity: 0;\n    transition: opacity 0.4s;\n    position: absolute;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    grid-gap: 12px;\n}\n\n.horizontal .placeholder {\n    top: -40px;\n    left: 0;\n}\n\n.vertical .placeholder {\n    left: 28px;\n    top: 40px;\n}\n\n.open .placeholder {\n    opacity: 1;\n}\n\n/*.smaller:not(.open) {*/\n/*    --box-width: 224px;*/\n/*    --box-height: 105px;*/\n/*}*/\n\n.smaller .boxInner {\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.smaller {\n    margin: auto;\n}\n\n@media screen-md-max {\n    .box:not(.open).smaller {\n        margin-right: 0;\n    }\n\n    .box.open.smaller {\n        margin-right: 7px;\n    }\n\n    .box {\n        /*--box-width: 150px !important;*/\n        /*--box-height: 70px !important;*/\n        /*width: 150px !important;*/\n        /*min-width: 150px !important;*/\n        /*height: 70px !important;*/\n        /*min-height: 70px !important;*/\n        /*padding: 10px;*/\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"box": `styles_box__0yj2J`,
	"open": `styles_open__Tsm2e`,
	"vertical": `styles_vertical__Gbefe`,
	"smaller": `styles_smaller__A9U6Q`,
	"boxInner": `styles_boxInner__4WAHc`,
	"boxContent": `styles_boxContent__a5oph`,
	"horizontal": `styles_horizontal__4RlLx`,
	"bottom": `styles_bottom__xWFj3`,
	"absolute": `styles_absolute__oIuM9`,
	"placeholder": `styles_placeholder__qVABa`,
	"justify": `styles_justify__VumoO`
};
export default ___CSS_LOADER_EXPORT___;
